import Arrow from "@/assets/arrow.svg";

const ArrowSeparator = () => {
  return (
    <div className="flex justify-stretch items-center w-full py-3">
      <div className="h-[1px] bg-white/10 basis-full overflow-visible relative">
        <span className="h-7 w-7 flex items-center justify-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#262628]">
          <Arrow />
        </span>
      </div>
    </div>
  );
};

export default ArrowSeparator;
